import { render, staticRenderFns } from "./ShowProgram.vue?vue&type=template&id=16f946e1&scoped=true&"
import script from "./ShowProgram.vue?vue&type=script&lang=js&"
export * from "./ShowProgram.vue?vue&type=script&lang=js&"
import style0 from "./ShowProgram.vue?vue&type=style&index=0&id=16f946e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f946e1",
  null
  
)

export default component.exports